import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface GitHubRepository {
  id: number;
  name: string;
  fullName: string;
  description: string | null;
  defaultBranch: string;
  isPrivate: boolean;
  htmlUrl: string;
  cloneUrl: string;
  language: string | null;
  updatedAt: string | null;
  pushedAt: string | null;
  sizeKb: number;
  archived: boolean;
}

export interface GitHubApiResponse<T> {
  statusCode: number;
  success: boolean;
  message: string;
  data: T;
}

export interface GitHubRepositoryListData {
  repositories: GitHubRepository[];
  totalCount: number;
  hasNextPage: boolean;
}

export interface GitHubConnectionSummary {
  id: string;
  name: string;
  organizationName: string;
  status: string;
  createdAt: string;
}

export interface GitHubConnectionListData {
  connections: GitHubConnectionSummary[];
}

@Injectable({
  providedIn: 'root'
})
export class GitHubConnector {
  private baseUrl = `${environment.apiUrl}/github`;

  constructor(private http: HttpClient) {}

  getConnections(): Observable<GitHubApiResponse<GitHubConnectionListData>> {
    return this.http.get<GitHubApiResponse<GitHubConnectionListData>>(`${this.baseUrl}/connections`);
  }

  getRepositories(connectionId: string, page = 1, perPage = 100): Observable<GitHubApiResponse<GitHubRepositoryListData>> {
    return this.http.get<GitHubApiResponse<GitHubRepositoryListData>>(
      `${this.baseUrl}/connections/${connectionId}/repositories?page=${page}&perPage=${perPage}`
    );
  }

  getProcessedRepositories(connectionId: string, page = 1, perPage = 100): Observable<GitHubApiResponse<GitHubRepositoryListData>> {
    return this.http.get<GitHubApiResponse<GitHubRepositoryListData>>(
      `${this.baseUrl}/connections/${connectionId}/repositories/processed?page=${page}&perPage=${perPage}`
    );
  }

  getUnprocessedRepositories(connectionId: string, page = 1, perPage = 100): Observable<GitHubApiResponse<GitHubRepositoryListData>> {
    return this.http.get<GitHubApiResponse<GitHubRepositoryListData>>(
      `${this.baseUrl}/connections/${connectionId}/repositories/unprocessed?page=${page}&perPage=${perPage}`
    );
  }
}
